import pb from "lib/pocketbase";
import { useState, useContext, useRef } from "react";
import { useForm } from "react-hook-form";
import { UserContext } from "lib/UserContext";

export default function Login() {
  const [isLoading, setLoading] = useState(false);
  const { register, handleSubmit, reset } = useForm();
  const { user, setUser } = useContext(UserContext);
  //  const inputRef = useRef(null);

  async function handleLogin(data) {
    try {
      pb.authStore.clear();
      setLoading(true);
      const authData = await pb
        .collection("users")
        .authWithPassword(data.email, data.password);
      setUser(authData.record);
      console.log(`logged in user: ${authData.record.name}`);
      // navigate("/dashboard");
    } catch (e) {
      alert(e);
      console.log(e);
      reset();
    }
    setLoading(false);
  }

  return (
    <div className="card shadow">
      <h4 className="card-header text-center">Log In</h4>
      <div className="card-body ">
        <form className="" id="login" onSubmit={handleSubmit(handleLogin)}>
          <div className="mb-3 d-flex flex-column">
            <input
              className="form-control mb-3"
              type="text"
              placeholder="username"
              //ref={inputRef}
              {...register("email")}
            />
            <input
              type="password"
              className="form-control mb-4"
              placeholder="password"
              {...register("password")}
            />
            <button
              className="btn btn-primary"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Log In →"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
